import React, { useEffect, useState } from "react";
import "../../../On_going/Published/Published_Q_list/publishedQListActivity.css";
import PdfQTypeActivity from "./PublishQuestionType/PdfType/PdfQTypeActivity";
import { Link, NavLink, useLocation } from "react-router-dom";
import axios from "../../../../../axios";
import OpenThreeDotPopup from "./OpenThreeDotPopup";
import { Popup } from "semantic-ui-react";

import CnfirmDeletePublished from "./Cnfirm_Delete_Published";
import CompletedASList from "./CompletedASList";
import PrintActivity from "./PrintActivity";
import { Book, FlaskConical, Award } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PublishedQListActivity({
  publishedActivity_id,
  onClose,
}) {
  const [deletePublished, setDeletePublished] = useState();
  const [publicData, setPublicData] = useState({
    publicActivitys: [],
    completeSList: [],
  });
  let isFromDcm = localStorage.getItem("from");
  let supplement_id = JSON.parse(localStorage.getItem("supplementId"));
  const { publicActivitys, completeSList } = publicData;
  //Add loader
  const [isGettingData, setIsGettingData] = useState(true);
  const [click, setClick] = useState();

  const state = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const getCreatedActivity = async () => {
      const activity_id =
        publishedActivity_id || state?.state?.publishedActivity_id;
      console.log("activity_id", activity_id);
      try {
        const res = await axios.get(
          `/api/v1/homework/activity/getById/${activity_id}`,
        );
        setIsGettingData(false);
        const completeSList = await axios.get(
          `/api/v1/homework/studentActivity/getByAcivityId/${activity_id}?status=pending`,
        );
        // console.log("completeSList", completeSList)
        res &&
          completeSList &&
          setPublicData({
            publicActivitys: res.data.data,
            completeSList: completeSList.data.data,
          });
        setIsGettingData(false);
      } catch (error) {
        setIsGettingData(false);
      }
    };
    getCreatedActivity();
  }, []);
  const myList = [completeSList];
  const totalLength = myList
    .map((array) => array.length)
    .reduce((sum, length) => sum + length, 0);

  // Helper function to render grade/marks info
  const renderGradeOrMarksInfo = () => {
    const entryType = publicActivitys?.entryType;
    const totalMarks = publicActivitys?.total_marks;
    const gradeScale = publicActivitys?.gradeScaleId;

    // If entryType is "None" or undefined, show nothing
    if (!entryType || entryType === "None") {
      return null;
    }

    // If entryType is "Marks", show total marks
    if (entryType === "Marks") {
      return (
        <div className="text-muted">
          <strong>Total Marks: </strong> {totalMarks || 0}
        </div>
      );
    }

    // If entryType is "Grade", show grade scale info
    if (entryType === "Grade" && gradeScale) {
      return (
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <div className="text-muted d-flex align-items-center gap-1">
            <Award size={16} />
            <strong>Grade Scale: </strong>
            <span className="fw-semibold">{gradeScale.name}</span>
          </div>
          <div className="d-flex gap-1 flex-wrap">
            {gradeScale.grades?.map((grade) => (
              <span
                key={grade.grade}
                className="badge"
                style={{
                  backgroundColor:
                    grade.resultStatus === "Pass" ? "#d4edda" : "#f8d7da",
                  color: grade.resultStatus === "Pass" ? "#155724" : "#721c24",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "11px",
                  fontWeight: 600,
                }}
              >
                {grade.grade}: {grade.minMarks}-{grade.maxMarks}
              </span>
            ))}
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{ backgroundColor: "rgba(0,0,0,0.4)", zIndex: 9999 }}
    >
      <div
        className="bg-white rounded shadow"
        style={{
          width: "90%",
          maxWidth: "650px",
          maxHeight: "800px",
          overflowY: "auto",
          backgroundColor: "#FFF6EF",
        }}
      >
        {!isGettingData ? (
          <>
            {/* Header */}
            <div
              className="p-4"
              style={{ backgroundColor: "#fdefe4", height: "120px" }}
            >
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div
                  className="d-flex align-items-center gap-2"
                  style={{ minWidth: 0 }}
                >
                  <Book size={20} />

                  <h5
                    className="fw-bold m-0"
                    style={{
                      maxWidth: "250px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={publicActivitys?.name}
                  >
                    {publicActivitys?.name}
                  </h5>
                </div>

                <button
                  className="btn btn-sm btn-outline-secondary rounded-circle"
                  onClick={() => {
                    if (onClose) {
                      onClose();
                      return;
                    }

                    navigate("/liveSession", {
                      state: {
                        supplement_id:
                          state?.state?.supplement_id || supplement_id,
                        standardsName: state?.state?.standard,
                        sectionName: state?.state?.section,
                      },
                      replace: true,
                    });
                  }}
                >
                  ✕
                </button>
              </div>
              <div className="d-flex align-items-center mb-2 gap-2 flex-wrap">
                <span className="badge bg-light text-dark d-flex align-items-center">
                  📘 {publicActivitys?.subject_id?.name}
                </span>
                <span className="badge bg-warning text-white">Published</span>

                {/* Show Entry Type Badge */}
                {publicActivitys?.entryType &&
                  publicActivitys?.entryType !== "None" && (
                    <span
                      className="badge"
                      style={{
                        backgroundColor:
                          publicActivitys?.entryType === "Grade"
                            ? "#6366f1"
                            : "#28a745",
                        color: "#fff",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        fontSize: "11px",
                        fontWeight: 600,
                      }}
                    >
                      {publicActivitys?.entryType}
                    </span>
                  )}

                <div className="d-flex align-items-center ms-2">
                  <img
                    src="/images/memberListIcon.png"
                    alt=""
                    className="border rounded-circle me-1"
                    style={{
                      width: "36px",
                      height: "36px",
                      border: "1px solid gray",
                    }}
                    onClick={() => setClick(true)}
                  />
                  <Popup
                    trigger={
                      <div
                        className="d-flex align-items-center justify-content-center border rounded px-2 py-1"
                        style={{ cursor: "pointer" }}
                      >
                        {totalLength}
                      </div>
                    }
                    content={
                      totalLength > 0 && (
                        <CompletedASList
                          completeList={completeSList}
                          setClick={setClick}
                        />
                      )
                    }
                    position="bottom right"
                    on="click"
                    positionFixed
                    style={{ zIndex: 10000 }}
                  />
                </div>
              </div>
            </div>

            {/* Body */}
            <div className="p-4" style={{ backgroundColor: "#f3f3f3" }}>
              {/* 🆕 Grade/Marks Info Section */}
              <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                {renderGradeOrMarksInfo()}

                {/* Show Total Marks as fallback if no entryType or entryType is None */}
                {(!publicActivitys?.entryType ||
                  publicActivitys?.entryType === "None") && (
                  <div className="text-muted">
                    <strong>Total Marks: </strong>{" "}
                    {publicActivitys?.total_marks || 0}
                  </div>
                )}
              </div>

              <div
                className="Published_Activity_text text-muted mb-3 orange-scrollBar"
                style={{
                  maxHeight: "90px",
                  width: "100%",
                  overflowY: "auto",
                  overflowX: "hidden",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  lineHeight: "1.6",
                  paddingRight: "6px",
                }}
                title={publicActivitys?.description}
              >
                {publicActivitys?.description}
              </div>

              {/* ── Selected Lab Preview ── */}
              {publicActivitys?.lab_ref && (
                <div
                  className="mt-4 p-3"
                  style={{
                    borderRadius: "18px",
                    border: "2px solid #6366f1",
                    backgroundColor: "#f5f3ff",
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  {/* Thumbnail */}
                  <div
                    style={{
                      width: "130px",
                      height: "85px",
                      flexShrink: 0,
                      borderRadius: "12px",
                      overflow: "hidden",
                      border: "1px solid #c4b5fd",
                      backgroundColor: "#fff",
                    }}
                  >
                    <img
                      src={publicActivitys?.lab_ref?.thumbnailUrl}
                      alt={publicActivitys?.lab_ref?.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  </div>

                  {/* Content */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <FlaskConical size={18} color="#4f46e5" />

                      <div
                        style={{
                          fontWeight: 700,
                          color: "#4338ca",
                          fontSize: "16px",
                        }}
                      >
                        {publicActivitys?.lab_ref?.title}
                      </div>
                    </div>

                    {/* Tags */}
                    <div className="d-flex gap-2 flex-wrap mb-2">
                      <span
                        style={{
                          backgroundColor: "#e0e7ff",
                          color: "#4338ca",
                          padding: "4px 10px",
                          borderRadius: "999px",
                          fontSize: "12px",
                          fontWeight: 600,
                        }}
                      >
                        Lab Activity
                      </span>

                      <span
                        style={{
                          backgroundColor: "#f3e8ff",
                          color: "#7c3aed",
                          padding: "4px 10px",
                          borderRadius: "999px",
                          fontSize: "12px",
                          fontWeight: 600,
                        }}
                      >
                        {publicActivitys?.lab_ref?.estimatedDurationMinutes}{" "}
                        mins
                      </span>
                    </div>

                    {/* Description */}
                    <div
                      style={{
                        color: "#64748b",
                        fontSize: "13px",
                        lineHeight: 1.5,
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {publicActivitys?.lab_ref?.description}
                    </div>
                  </div>

                  {/* Open Button */}
                  <button
                    className="btn btn-sm"
                    style={{
                      backgroundColor: "#6366f1",
                      color: "#fff",
                      borderRadius: "10px",
                      padding: "8px 14px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();

                      const previewData = {
                        selectedLab: publicActivitys?.lab_ref,

                        activityData: {
                          title: publicActivitys?.name,

                          description: publicActivitys?.description,

                          className: publicActivitys?.standard_id?.name,

                          subjectName: publicActivitys?.subject_id?.name,

                          chapterName: publicActivitys?.book_id?.name || "",

                          duration: publicActivitys?.duration || "20 minutes",
                        },
                      };

                      localStorage.setItem(
                        "activityPreviewData",
                        JSON.stringify(previewData),
                      );

                      const features = [
                        "toolbar=no",
                        "location=no",
                        "directories=no",
                        "status=no",
                        "menubar=no",
                        "scrollbars=yes",
                        "resizable=yes",
                        "fullscreen=yes",
                        `width=${window.screen.availWidth}`,
                        `height=${window.screen.availHeight}`,
                        "top=0",
                        "left=0",
                      ].join(",");

                      const newWindow = window.open(
                        "/activity-lab-preview.html",
                        "_blank",
                        features,
                      );

                      if (newWindow) {
                        newWindow.moveTo(0, 0);

                        newWindow.resizeTo(
                          window.screen.availWidth,
                          window.screen.availHeight,
                        );

                        newWindow.focus();
                      }
                    }}
                  >
                    Open Lab
                  </button>
                </div>
              )}

              {(publicActivitys?.attachments?.length > 0 ||
                publicActivitys?.correctAnswer?.attachment?.length > 0) && (
                <>
                  <h6 className="fw-semibold mt-4 mb-2">📎 All Attachments</h6>
                  <div className="d-flex gap-2 flex-wrap">
                    {[
                      ...(publicActivitys.attachments || []),
                      ...(publicActivitys.correctAnswer?.attachment || []),
                    ].map((attachment, index) => (
                      <PdfQTypeActivity
                        key={index}
                        publishedAttachData={publicActivitys}
                        attachments={attachment}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>

            {/* Delete Confirmation */}
            {deletePublished && (
              <CnfirmDeletePublished
                setDelete={setDeletePublished}
                activity_id={publishedActivity_id}
                activitys={publicActivitys}
              />
            )}
          </>
        ) : (
          <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
        )}
      </div>
    </div>
  );
}
